import api from "../config/Api";

export const uploadToLocalhost = async (file: File): Promise<string | null> => {
    const formData = new FormData();
    formData.append("file", file);

    const jwt = localStorage.getItem("jwt");

    try {
        const response = await api.post("/api/images/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${jwt}`, 
            },
        });
        return response.data.url;
    } catch (error) {
        console.error("Error uploading to local backend storage:", error);
        return null;
    }
};